// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los números que se muestran en los display
 * @param {*} scene 
 */
export function cargaAssetsNumerosDisplay(scene) {
  scene.load.image(
    "numeroDisplay0",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay0Resized.png"
  );
  scene.load.image(
    "numeroDisplay1",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay1Resized.png"
  );
  scene.load.image(
    "numeroDisplay2",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay2Resized.png"
  );
  scene.load.image(
    "numeroDisplay3",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay3Resized.png"
  );
  scene.load.image(
    "numeroDisplay4",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay4Resized.png"
  );
  scene.load.image(
    "numeroDisplay5",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay5Resized.png"
  );
  scene.load.image(
    "numeroDisplay6",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay6Resized.png"
  );
  scene.load.image(
    "numeroDisplay7",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay7Resized.png"
  );
  scene.load.image(
    "numeroDisplay8",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay8Resized.png"
  );
  scene.load.image(
    "numeroDisplay9",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplay9Resized.png"
  );
  scene.load.image(
    "numeroDisplayVacio",
    ROUTES.rutaTragamonedasNumerosDisplay + "/numeroDisplayVacioResized.png"
  );
}
